import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';

export class GATrackingCarouselButtonEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return this.payload.action;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GATrackingEventType.CarouselButton,
      label: this.payload.label,
      gtmCustom: {
        category: this.payload.category
      }
    };
  }
}
